<div class="flex-control flex-column">
  <app-tabs>
    <li *ngFor="let role_type of role_types" [class.active]="tabs_Service.not_active() && selected_menu == role_type.name">
      <button [(ngModel)]=selected_menu name="selected_menu" [value]="role_type.id" ngDefaultControl (click)="setRoleType(role_type.id,role_type.name)" class="btn btn-default p-btn"><i [ngClass]="iconMapping(role_type.name)" class="p-sm"></i>{{role_type.name.charAt(0).toUpperCase()+ role_type.name.slice(1)}}</button>
    </li>
  </app-tabs>
  <app-filter class="flex-control flex-column" [hidden]="tabs_Service.is_active()" *ngIf="role_type" [profile_type]="role_type"></app-filter>
</div>
